var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-chart has-spinner"},[(_vm.isLoading)?_c('img',{staticClass:"has-spinner__spinner",attrs:{"src":"/static/img/loaders/spinner.svg"}}):_vm._e(),_vm._v(" "),_c('vue-chart',{key:_vm.keyIdx,attrs:{"columns":_vm.chartColumns,"options":_vm.chartOptions,"rows":_vm.chartRows,"chart-type":"LineChart"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347417ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/analytics/reviews/AverageRating.vue
// module id = null
// module chunks = 